<template>
	<div>
		<div class="main" v-if="!isLoading">
			<BaseSelect
				ref="LawyerOfficeSelect"
				v-model="selectedLawyerOffice"
				:options="lawyerOfficeOptions"
				:label="$t('lawyers_office')"
				:required="false"
				:allow-empty="true"
				:disable-search="false"
			/>

			<div v-if="selectedLawyerOffice" class="mt-6">
				<BaseCardRow :value="selectedLawyerOffice.name" :label="$t('name')" />

				<BaseCardRow :value="street" :label="$t('street')" />

				<BaseCardRow :value="city" :label="$t('city')" />

				<BaseCardRow :value="selectedLawyerOffice.phoneNumber" :label="$t('phone')" />

				<BaseCardRow :value="selectedLawyerOffice.email" :label="$t('e_mail')" />
			</div>
<!--
			<div class="mt-6">
				<BaseButton disabled>
					{{ $t('create_new_lawyer') }}
				</BaseButton>
			</div>
-->
			<div class="flex justify-end mt-6">
				<BaseButton @click="save" :disabled="isSaving" class="btn-blue">
					{{ $t('general.save') }}
				</BaseButton>
			</div>
		</div>

		<LoadingSpinner v-else />
	</div>
</template>

<script>
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow.vue';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';

import DamageAssessorCaseRepository from '@/api/repositories/DamageAssessorCaseRepository';

import { concatArray } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'DamageAssessorCaseEditLawyerModal',

	mixins: [Authentication],

	components: {
		BaseSelect,
		BaseButton,
		BaseCardRow,
		LoadingSpinner,
	},

	data() {
		return {
			isLoading: true,

			isSaving: false,

			damageAssessorCase: null,

			lawyerOffices: [],

			selectedLawyerOffice: null,
		};
	},

	computed: {
		lawyerOfficeOptions() {
			return this.lawyerOffices
				.filter(lawyer => lawyer != null)
				.map(lawyer => ({
					...lawyer,

					display: lawyer.name,

					value: lawyer.id,
				}));
		},
		street() {
			return concatArray([this.selectedLawyerOffice?.street, this.selectedLawyerOffice?.houseNumber]) || '-';
		},
		city() {
			return concatArray([this.selectedLawyerOffice?.city?.zipCode, this.selectedLawyerOffice?.city?.name]) || '-';
		},
		selectedLawyerOfficeId() {
			return this.selectedLawyerOffice?.id ?? this.selectedLawyerOffice?.value ?? null;
		},
	},

	mounted() {
		this.loadData();
	},

	methods: {
		loadData() {
			this.isLoading = true;
			const repository = new DamageAssessorCaseRepository();
			repository
				.getDamageAssessorCaseDetail(this.$route.params.id)
				.then(caseResponse => {
					this.damageAssessorCase = caseResponse.data;
					return repository.getLawyerOffices();
				})
				.then(lawyerResponse => {
					this.lawyerOffices = (lawyerResponse.data ?? []).filter(lawyer => lawyer != null);
					this.setCurrentLawyerOffice();
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('please_check_input').toString(), 'error');
				})
				.finally(() => {
					this.isLoading = false;
				});
		},

		setCurrentLawyerOffice() {
			const currentLawyerOfficeId = this.damageAssessorCase?.lawyers_office?.id ?? null;

			if (!currentLawyerOfficeId) {
				this.selectedLawyerOffice = null;
				return;
			}

			this.selectedLawyerOffice = this.lawyerOfficeOptions.find(lawyer => String(lawyer.id) === String(currentLawyerOfficeId)) ?? null;
		},

		save() {
			if (this.isSaving || !this.damageAssessorCase) {
				return;
			}

			if (!this.selectedLawyerOfficeId) {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				return;
			}

			this.isSaving = true;

			const payload = {
				lawyers_office: {
					id: this.selectedLawyerOfficeId,
				},
			};

			new DamageAssessorCaseRepository()
				.updateDamageAssessorCase(this.damageAssessorCase.id, payload)
				.then(() => {
					this.$root.$emit('updateCase');
					this.$store.commit('setConfirmLeaving', false);
					this.$router.go(-1);
					return this.$swal(this.$t('general.success').toString(), this.$t('general.changes_saved').toString(), 'success');
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
				})
				.finally(() => {
					this.isSaving = false;
				});
		},
	},
};
</script>

<style scoped></style>
